import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { Cargo } from "../../types/rh/cargo"
import { useCargoStore } from "../../stores/rh/cargo"
import { Box, Breadcrumbs, FormControlLabel, FormGroup, IconButton, Link, Switch, Tab, Tabs, Typography } from "@mui/material"
import DynamicIcon from "../../components/global/DynamicIcon"
import AlertErro from "../../components/global/AlertErro"
import FormContainer from "../../components/global/InputContainer"
import Input from "../../components/global/Input"
import LoadingPage from "../../components/global/LoadingPage"
import BottomBar from "../../components/global/BottomBar"
import PrimaryButton from "../../components/global/PrimaryButton"
import DeleteDialog from "../../components/global/DeleteDialog"
import { rhAPI } from "../../api"
import SwitchPrimary from "../../components/global/Switch"
import { InputValidation } from "../../types/global/inputErro"
import { AppContext } from "../../common/contexts/app_context/app_context"

function CargoRegister() {
  const navigate = useNavigate()
  const { setNoticeOpen, setMessageNotice } = useContext(AppContext)
  const { setCargos, filters } = useCargoStore()
  const [cargo, setCargo] = useState<Cargo>(new Cargo())
  const [cargoBackup, setCargoBackup] = useState<Cargo>(new Cargo())
  const { selectedCargoId } = useCargoStore()
  const [loadingPage, setLoadingPage] = useState(false)
  const [erroLoadPage, setErroLoadPage] = useState(true)
  const [messageErroLoadPage, setMessageErroLoadPage] = useState("")
  const [erroSave, setErroSave] = useState(false)
  const [messageErroSave, setMessageErroSave] = useState("")
  const [valueTab, setValueTab] = useState(1)
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false)

  const [descricao, setDescricao] = useState(new InputValidation("O campo de descrição é obrigatório."))
  const [atribuicoes, setAtribuicoes] = useState(new InputValidation("O campo de atribuições é obrigatório."))

  useEffect(() => {
    loadPage()
  }, [])

  const loadPage = async () => {
    setErroLoadPage(false)
    setLoadingPage(true)
    if (selectedCargoId != 0) {
      const result = await rhAPI.getCargoById(selectedCargoId)
      if (result.statusCode == 200 && result.data) {
        setCargo(result.data)
        setCargoBackup(result.data)
      }
      else {
        setErroLoadPage(true)
        setMessageErroLoadPage(result.error?.Message ?? "Ocorreu um erro inesperado.")
      }
    }
    else {
      setCargo(new Cargo())
      setCargoBackup(new Cargo())
    }

    setLoadingPage(false)
  }


  const handleDelete = async () => {
    if (selectedCargoId != 0) {
      setLoadingPage(true)
      var result = await rhAPI.deleteCargo(selectedCargoId)
      if (result.statusCode == 200) {
        setCargos(filters)
        navigate("/Cargos_lista")
        setMessageNotice("Alterações realizadas com sucesso!")
        setNoticeOpen(true)
      }
      else {
        setDialogDeleteOpen(false)
        setErroSave(true)
        setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
        setMessageNotice("Ocorreu algum erro ao tentar deletar.")
        setNoticeOpen(true)
        setLoadingPage(false)
      }
    }
  }

  const handleSave = async () => {
    if (validateInputs()) {
      setLoadingPage(true)
      if (selectedCargoId != 0) {
        var result = await rhAPI.updateCargo(cargo)
        if (result.statusCode == 200) {
          setCargos(filters)
          navigate("/Cargos_lista")
          setMessageNotice("Alterações realizadas com sucesso!")
          setNoticeOpen(true)
        }
        else {
          setErroSave(true)
          setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
          setMessageNotice("Ocorreu algum erro ao tentar salvar.")
          setNoticeOpen(true)
        }
      }
      else {
        var result = await rhAPI.createCargo(cargo)
        if (result.statusCode == 200) {
          setCargos(filters)
          navigate("/Cargos_lista")
          setMessageNotice("Alterações realizadas com sucesso!")
          setNoticeOpen(true)
        }
        else {
          setErroSave(true)
          setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
          setMessageNotice("Ocorreu algum erro ao tentar salvar.")
          setNoticeOpen(true)
          setLoadingPage(false)
        }
      }
    }
  }

  const validateInputs = () => {
    if (!cargo.descricao) {
      setDescricao((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }
    if (!cargo.atribuicoes) {
      setAtribuicoes((item) => ({
        ...item,
        erro: true
      }))
      return false
    }
    setMessageNotice("Preencha todos os campos obrigatórios.")
    setNoticeOpen(true)
    return true
  }

  return (
    <>
      <div className="flex w-full gap-6 flex-col pb-[62px] md:px-10 md:pt-10 p-4">
        <div className=" flex gap-4 items-center">
          <IconButton
            onClick={() => {
              navigate("/Cargos_lista")
            }} >
            <DynamicIcon
              nameIcon="ArrowBackRounded"
              size={35}
              className="text-primary-green" />
          </IconButton>
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit" >
              RH
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => {
                navigate("/Cargos_lista")
              }}
            >
              Cargos
            </Link>
            <Typography className="text-primary-green">{selectedCargoId != 0 ? "Editar" : "Novo"} cargo</Typography>
          </Breadcrumbs>
        </div>
        {
          (loadingPage == false && erroLoadPage == false) &&
          <>
            <div className="div flex flex-col md:flex-row justify-between items-start gap-6">
              <div className="flex gap-2 flex-col items-start">
                <h1 className="text-3xl font-medium text-black dark:text-white">{selectedCargoId == 0 ? "Novo cargo" : cargoBackup.descricao}</h1>
                {
                  selectedCargoId != 0 &&
                  <div className="flex items-center gap-2">
                    <div
                      onClick={() => setDialogDeleteOpen(true)}
                      className="flex items-center gap-1 text-red-500 cursor-pointer dark:hover:bg-border-dark-gray hover:bg-hover-light-gray rounded-[4px] p-2">
                      <DynamicIcon nameIcon="DeleteForeverRounded" size={25} />
                      <h1 className="text-sm font-medium">Excluir cargo</h1>
                    </div>
                  </div>
                }
              </div>
            </div>
            {
              erroSave == true &&
              <div className="w-full">
                <AlertErro messageErro={messageErroSave} onTryAgain={async () => await handleSave()} onClose={() => setErroSave(false)} />
              </div>
            }
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { background: '#009C4E' } }}
                value={valueTab}
                onChange={(event: React.SyntheticEvent, newValue: number) => {
                  setValueTab(newValue);
                }}>
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Informações Gerais" value={1} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Treinamentos" value={2} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Habilidades " value={3} />
              </Tabs>
            </Box>
            {
              valueTab == 1 &&
              <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <FormContainer style="fullRow" title="Informações básicas">
                  <>
                    <SwitchPrimary
                      onChange={(y) => {
                        setCargo((x) => ({
                          ...x,
                          ativo: y.target.checked
                        }))
                      }}
                      checked={cargo.ativo}
                      name="Ativo"
                      label={cargo.ativo ? "Ativo" : "Inativo"}
                    />
                    <Input
                      variant="outlined"
                      label="Cargo(Descrição)"
                      required
                      value={cargo.descricao}
                      error={descricao.erro}
                      helperText={descricao.messageErro}

                      onChange={(x) => {
                        setDescricao((item) => ({
                          ...item,
                          erro: false
                        }))
                        setCargo((y) => ({
                          ...y,
                          descricao: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
                <FormContainer
                  title="Atribuições, responsabilidades e autoridades"
                  style="fullRow">
                  <>
                    <Input
                      variant="outlined"
                      label="Atribuições, responsabilidades e autoridades"
                      required
                      multiline
                      minRows={3}
                      value={cargo.atribuicoes}
                      error={atribuicoes.erro}
                      helperText={atribuicoes.messageErro}
                      onChange={(x) => {
                        setAtribuicoes((item) => ({
                          ...item,
                          erro: false
                        }))
                        setCargo((y) => ({
                          ...y,
                          atribuicoes: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
                <FormContainer
                  title="Escolaridade"
                  style="fullRow">
                  <>
                    <Input
                      variant="outlined"
                      label="Escolaridade"
                      multiline
                      minRows={3}
                      value={cargo.escolaridade}
                      onChange={(x) => {
                        setCargo((y) => ({
                          ...y,
                          escolaridade: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
                <FormContainer
                  title="Experiência"
                  style="fullRow">
                  <>
                    <Input
                      variant="outlined"
                      label="Experiência"
                      multiline
                      minRows={3}
                      value={cargo.experiencia}
                      onChange={(x) => {
                        setCargo((y) => ({
                          ...y,
                          experiencia: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
                <FormContainer
                  border={false}
                  title="Qualificações, conhecimentos e habilitações"
                  style="fullRow">
                  <>
                    <Input
                      variant="outlined"
                      label="Qualificações, conhecimentos e habilitações"
                      multiline
                      minRows={3}
                      value={cargo.qualificacoes}
                      onChange={(x) => {
                        setCargo((y) => ({
                          ...y,
                          qualificacoes: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
              </div>
            }
          </>
        }
        {
          (erroLoadPage == true && loadingPage == false) &&
          <AlertErro messageErro={messageErroLoadPage} onTryAgain={async () => await loadPage()} />
        }
        {
          loadingPage == true &&
          <LoadingPage />
        }
      </div >
      {
        (erroLoadPage == false) &&
        <BottomBar>
          <div className="w-full h-full items-center justify-end flex p-4 gap-4">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1 className="text-sm text-black dark:text-white" onClick={() => navigate("/Cargos_lista")}>Cancelar</h1>
            </div>
            <div className="w-[180px]">
              <PrimaryButton startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />} onClick={handleSave}>Salvar alterações</PrimaryButton>
            </div>
          </div>
        </BottomBar>
      }
      <DeleteDialog
        open={dialogDeleteOpen}
        onClose={() => setDialogDeleteOpen(false)}
        title={`Você realmente deseja excluir o cargo ${cargoBackup.descricao}?`}
        onDelete={handleDelete}
      />
    </>
  );
}

export default CargoRegister;